/**
 * Portão de módulo para a conta do Otto: o endereço de um módulo que o plano não tem mostra a VITRINE no lugar da tela
 * (docs/specs/otto/TDD.md §5, PRD AC-7). Não há redirecionamento nem guarda de rota por modo: o endereço continua o mesmo, e
 * o que aparece depende de o plano ter o módulo.
 *
 * Contas da plataforma passam direto, sem mudar nada (os módulos sem plano seguem escondidos ou com o painel de upgrade de
 * sempre). Superadmin e trial passam: em trial todas as chaves valem, e o sinal do modo continua sendo o plano.
 *
 * A vitrine só mostra e pede; as ações chegam como PORTAS (docs/specs/otto/VITRINE.md). Hoje existe uma: `talkToSales`, que
 * leva ao Suporte (a central de ajuda onde a conta fala com a Touchworks). As portas de experimento, contratação e pedido ao
 * administrador entram quando o produto decidir os fluxos (PRD §6.8, §6.10 e F6): enquanto não existem, a ação não aparece.
 *
 * @param {{ moduleKey: string, children: import('react').ReactNode }} props `moduleKey` é uma chave de `SHOWCASE_MODULES`
 */
import { Suspense } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { ModuleShowcase, showcaseModule } from '@/features/showcase';
import { useShowcaseShell } from './useShowcaseShell';
import { EXPERIENCE } from '@touchworks/shared/platform/experience.js';

export default function OttoModuleGate({ moduleKey, children }) {
    const { experience, hasFeature, isTrial, isSuperAdmin } = useAuth();
    const { canContract, talkToSales } = useShowcaseShell();
    const module = showcaseModule(moduleKey);

    const showsShowcase = Boolean(module)
        && experience === EXPERIENCE.OTTO
        && !isSuperAdmin()
        && !isTrial
        && !hasFeature(module.feature);

    if (!showsShowcase) return children;
    return (
        <Suspense fallback={null}>
            <ModuleShowcase key={moduleKey} moduleKey={moduleKey} canContract={canContract} talkToSales={talkToSales} />
        </Suspense>
    );
}
